import { mutationResponseSchema, type MutationResponse } from '@console/types'
import { apiPost } from '../api.js'
import { fetchCsrfToken } from '../auth/api.js'

/**
 * All three Phase 6 mutations return the same union shape — a success
 * receipt or a fingerprint conflict, both HTTP-successful from this
 * client's point of view (`alsoAccept: [409]`) so the caller discriminates
 * on the body rather than catching a thrown error to get at the conflict.
 */
async function postMutation(path: string, body: unknown): Promise<MutationResponse> {
  const csrfToken = await fetchCsrfToken()
  return apiPost(path, body, csrfToken, mutationResponseSchema, { alsoAccept: [409] })
}

export function approveRun(runId: string, fingerprint: string): Promise<MutationResponse> {
  return postMutation(`/runs/${encodeURIComponent(runId)}/approve`, { fingerprint })
}

export function refuseRun(
  runId: string,
  fingerprint: string,
  reason: string,
): Promise<MutationResponse> {
  return postMutation(`/runs/${encodeURIComponent(runId)}/refuse`, { fingerprint, reason })
}

export function ruleRun(
  runId: string,
  fingerprint: string,
  ruling: string,
): Promise<MutationResponse> {
  return postMutation(`/runs/${encodeURIComponent(runId)}/rule`, { fingerprint, ruling })
}
